import { Flex } from 'antd';
import { DesignProps } from 'api/DesignApi';
import imageLogoTextFull from 'assets/logo-text-full.svg';
import { NavLink, useNavigate } from 'react-router-dom';
import { isEternalOnlyBranding } from 'utils/branding';
import './PublicHeader.css';

function PublicHeader({ designProps }: { designProps?: DesignProps }) {
  const navigate = useNavigate();
  const eternalPrimaryColor = '#5449dc';
  const partnerName = designProps?.companyName?.trim() || 'Eternal';
  const useEternalOnlyBranding = isEternalOnlyBranding(partnerName);
  const partnerColor = useEternalOnlyBranding ? eternalPrimaryColor : designProps?.colorPrimary || eternalPrimaryColor;

  return (
    <div className="public-header">
      <Flex justify="space-between" gap={10} align="center" wrap={false}>
        <NavLink to="/" className="logo-container">
          <img src={designProps?.logoUrl ?? imageLogoTextFull} alt={`${partnerName} logo`} className="logo" />
          {!useEternalOnlyBranding && (
            <div className="partner-meta">
              <div className="partner-name">{partnerName}</div>
              <div className="partner-subtitle">In partnership with Eternal</div>
            </div>
          )}
        </NavLink>

        <Flex gap={10} align="center" className="public-header-actions">
          <button
            type="button"
            className="public-header-link"
            style={{ color: partnerColor }}
            onClick={() => navigate('/login')}
          >
            Sign in
          </button>
        </Flex>
      </Flex>
    </div>
  );
}

export default PublicHeader;
